export function capitalize(s: string) {
  return s ? `${s.charAt(0).toUpperCase()}${s.slice(1)}` : ''
}

export function getFullMonth(locale: string) {
  return (d: Date) => {
    const date = new Date(d)
    return `${capitalize(date.toLocaleString(locale, { month: 'long', year: 'numeric' }))}`
  }
}

export function getFullYear(locale: string) {
  return (d: Date) => {
    const date = new Date(d)
    return `${capitalize(date.toLocaleString(locale, { year: 'numeric' }))}`
  }
}

export function getFullDate(locale: string) {
  return (d: Date) => {
    const date = new Date(d)
    return `${capitalize(date.toLocaleString(locale, { month: 'long', day: 'numeric', year: 'numeric' }))}`
  }
}

export const range = (one: number, two?: number) => {
  const end = typeof two === 'number' ? two : one
  const start = typeof two === 'number' ? one : 0
  const arr = []
  for (let i = start; i < end; i = i + 1) {
    arr.push(i)
  }

  return arr
}
